import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María G.', 'Juan P.', 'Ana L.', 'Carlos M.', 'Sofía R.', 'Lucas D.', 'Laura B.', 'Martín S.', 'Florencia T.', 'Diego F.', 'Valentina C.', 'Pablo H.', 'Camila V.', 'Nicolás G.', 'Julieta M.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Corrientes', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Juan'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 4000);
    // Loop
    const interval = setInterval(() => {
      triggerPopup();
    }, Math.random() * (15000 - 8000) + 8000); // Random between 8-15s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerPopup = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Auto dismiss
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 max-w-sm w-full animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-282">
      <div className="bg-white rounded-lg shadow-xl border-l-4 border-emerald-500 p-4 flex items-start gap-3 relative" data-id="element-283">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-284">
          <X size={14} data-id="element-285" />
        </button>

        <div className="bg-emerald-100 rounded-full p-2 shrink-0" data-id="element-286">
          <CheckCircle2 className="w-5 h-5 text-emerald-600" data-id="element-287" />
        </div>

        <div data-id="element-288">
          <p className="text-sm font-medium text-gray-900" data-id="element-289">
            ¡Nueva compra realizada!
          </p>
          <p className="text-sm text-gray-600 mt-1" data-id="element-290">
            <span className="font-semibold" data-id="element-291">{data.name}</span> de {data.city}{' '}
            acaba de comprar{' '}
            <span className="italic" data-id="element-292">Proyecto Organizacional 360</span>
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-293">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}